/**
 *
 * FNAnalysisFNStatementsCashFlow
 *
 */

import React, { Component } from "react";

import { getRequest } from "../api/ApiService";
import { logError } from "../services/utils";

import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";

// Components

/**
 * Price in millions.
 */
const PriceInMillions = ({ price, baseClassName }) => {
  if (typeof price !== "number") {
    return <div className={baseClassName}>n/a</div>;
  }

  let newPrice;
  if (price < 0) {
    newPrice = (price / 1000000).toFixed(2) * -1;
    return (
      <div className={`red ${baseClassName}`}>{`-$${newPrice}M`}</div>
    );
  } else {
    newPrice = (price / 1000000).toFixed(2);
    return <div className={baseClassName}>{`$${newPrice}M`}</div>;
  }
};

/**
 * Table Head
 */

const TableHead = ({ rounds }) => (
  <thead>
    <tr>
      <th className="table-title text-center">
        <span />
      </th>
      {rounds.map((round, i) => (
        <th key={i} className="table-title title-gray text-center">
          YEAR {round.number}
        </th>
      ))}
    </tr>
  </thead>
);

/**
 * Table row contents
 */

const TableRowContentWhite = ({ cashFlow, title }) => (
  <tr className="text-center">
    <th className="description">{title ? title : cashFlow.name}</th>
    {Object.keys(cashFlow.data).map(round_number => {
      let data = cashFlow.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row contents with gray background color.
 */

const TableRowContentGray = ({ cashFlow }) => (
  <tr className="text-center bg-gray none-shadow">
    <th className="description">{cashFlow.name}</th>
    {Object.keys(cashFlow.data).map(round_number => {
      let data = cashFlow.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row contents with dim gray background color.
 */

const TableRowContentDimGray = ({ cashFlow }) => (
  <tr className="text-center dim-gray none-shadow">
    <th className="description">
      <strong>{cashFlow.name}</strong>
    </th>
    {Object.keys(cashFlow.data).map(round_number => {
      let data = cashFlow.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row title.
 */

const TableRowContentHeader = ({ title, rounds }) => (
  <tr className="text-center">
    <th className="sub-title title-sky-blue">{title}</th>
    {rounds.map((round, i) => (
      <td key={i}>
        <div className="row flex">
          <div className="col-xs-6" />
          <div className="col-xs-6" />
          <div className="col-xs-6" />
        </div>
      </td>
    ))}
  </tr>
);

/**
 * Table row sub header.
 */

const TableRowContentSubheader = ({ title, rounds }) => (
  <tr className="text-center">
    <th className="sub-title">{title}</th>
    {rounds.map((round, i) => (
      <td key={i}>
        <div className="row flex">
          <div className="col-xs-6" />
          <div className="col-xs-6" />
          <div className="col-xs-6" />
        </div>
      </td>
    ))}
  </tr>
);

/**
 *
 * FNAnalysisFNStatementsCashFlow
 *
 */
class FNAnalysisFNStatementsCashFlow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roundInUrl: props.roundInUrl,
      cashFlow: {
        beginningCash: {
          name: "Beginning Cash",
          data: {}
        },
        capitalExpenditurePurchases: {
          name: "Capital Expenditure Purchases",
          data: {}
        },
        capitalExpenditureSales: {
          name: "Capital Expenditure Sales",
          data: {}
        },
        cashpaymentforIncomeTaxes: {
          name: "Cash payment for Income Taxes",
          data: {}
        },
        cashpaymentforInterests: {
          name: "Cash payment for Interests",
          data: {}
        },
        cashpaymentsforOperatingexpenses: {
          name: "Cash payments for Operating expenses",
          data: {}
        },
        cashpaymentsforPurchases: {
          name: "Cash payments for Purchases",
          data: {}
        },
        cashpaymentsforWages: {
          name: "Cash payment for Wages",
          data: {}
        },
        cashreceivedfromCustomers: {
          name: "Cash received from Customers",
          data: {}
        },
        debtBorrowed: {
          name: "Debt Borrowed",
          data: {}
        },
        debtRepaid: {
          name: "Debt Repaid",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        endingCash: {
          name: "Ending Cash",
          data: {}
        },
        investmentPurchases: {
          name: "Investment Purchases",
          data: {}
        },
        investmentSales: {
          name: "Investment Sales",
          data: {}
        },
        netChangeinCash: {
          name: "Net Change in Cash",
          data: {}
        },
        stockIssuance: {
          name: "Stock Issuance",
          data: {}
        },
        stockRepurchase: {
          name: "Stock Repurchase",
          data: {}
        },
        totalCashFlowsfromFinancing: {
          name: "Total Cash Flows from Financing",
          data: {}
        },
        totalCashFlowsfromInvesting: {
          name: "Total Cash Flows from Investing",
          data: {}
        },
        totalCashFlowsfromOperations: {
          name: "Total Cash Flows from Operations",
          data: {}
        }
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.loadState();
        }
      );
    }
  }

  getCashflow() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/cashflow/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  loadState = () => {
    if (this.props.rounds.length === 0) {
      this.timer = setTimeout(this.loadState, 1000);
      return;
    }

    this.clearData();
    this.fetchData();
  };

  clearData() {
    let cashFlow = { ...this.state.cashFlow };
    let headRounds = this.headRounds;

    for (let key in cashFlow) {
      cashFlow[key].data = {};
      headRounds.forEach(round => {
        cashFlow[key].data[round.number] = {
          value: 0
        };
      });
    }

    this.setState({
      cashFlow
    });
  }

  fetchData() {
    this.getCashflow()
      .then(res => {
        const cashFlow = { ...this.state.cashFlow };

        for (let key in cashFlow) {
          res.body.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = cashFlow[key].name;

            if (item[hash]) {
              cashFlow[key].data[round_number].value = item[hash];
            }
          });
        }

        this.setState({
          cashFlow
        });
      })
      .catch(err => {
        logError(err, "FNAnalysisFNStatementsCashFlow", "componentDidMount");
      });
  }

  componentDidMount() {
    this.loadState();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  get headRounds() {
    const { roundInUrl } = this.state;
    const { currentRound, rounds } = this.props;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return rounds.filter(i => i.number <= current_round);
  }

  render() {
    const {
      beginningCash,
      capitalExpenditurePurchases,
      capitalExpenditureSales,
      cashpaymentforIncomeTaxes,
      cashpaymentforInterests,
      cashpaymentsforOperatingexpenses,
      cashpaymentsforPurchases,
      cashpaymentsforWages,
      cashreceivedfromCustomers,
      debtBorrowed,
      debtRepaid,
      dividends,
      endingCash,
      investmentPurchases,
      investmentSales,
      netChangeinCash,
      stockIssuance,
      stockRepurchase,
      totalCashFlowsfromFinancing,
      totalCashFlowsfromInvesting,
      totalCashFlowsfromOperations
    } = this.state.cashFlow;
    const headRounds = this.headRounds;

    return (
      <div className="panel-dashboard-white-full">
        <h5 className="title-sky-blue">
          Cash Flows
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="sm"
            {...TypeformContent.CASH_FLOWS}
          />
        </h5>
        <div className="table-responsive fn-results-table">
          <table className="table border-analysis mb-20">
            <TableHead rounds={headRounds} />
            {Object.keys(beginningCash.data).length > 0 ||
              Object.keys(capitalExpenditurePurchases.data).length > 0 ||
              Object.keys(capitalExpenditureSales.data).length > 0 ? (
              <tbody>
                <TableRowContentSubheader
                  title="Cash Flows From Operations:"
                  rounds={headRounds}
                />
                <TableRowContentGray cashFlow={cashreceivedfromCustomers} />
                <TableRowContentWhite
                  cashFlow={cashpaymentsforPurchases}
                  title="Cash payment for Suppliers"
                />
                <TableRowContentGray cashFlow={cashpaymentsforWages} />
                <TableRowContentWhite
                  cashFlow={cashpaymentsforOperatingexpenses}
                  title="Cash payment for Operating expenses"
                />
                <TableRowContentGray cashFlow={cashpaymentforInterests} />
                <TableRowContentWhite cashFlow={cashpaymentforIncomeTaxes} />
                <TableRowContentDimGray
                  cashFlow={totalCashFlowsfromOperations}
                />

                <TableRowContentSubheader title="" rounds={headRounds} />
                <TableRowContentSubheader
                  title="Cash Flows From Investing:"
                  rounds={headRounds}
                />
                <TableRowContentGray cashFlow={capitalExpenditurePurchases} />
                <TableRowContentWhite cashFlow={capitalExpenditureSales} />
                <TableRowContentGray cashFlow={investmentPurchases} />
                <TableRowContentWhite cashFlow={investmentSales} />
                <TableRowContentDimGray
                  cashFlow={totalCashFlowsfromInvesting}
                />

                <TableRowContentSubheader title="" rounds={headRounds} />
                <TableRowContentSubheader
                  title="Cash Flow From Financing:"
                  rounds={headRounds}
                />
                <TableRowContentGray cashFlow={stockIssuance} />
                <TableRowContentWhite cashFlow={stockRepurchase} />
                <TableRowContentGray cashFlow={dividends} />
                <TableRowContentWhite cashFlow={debtBorrowed} />
                <TableRowContentGray cashFlow={debtRepaid} />
                <TableRowContentDimGray
                  cashFlow={totalCashFlowsfromFinancing}
                />

                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentHeader
                  title="Change In Cash"
                  rounds={headRounds}
                />
                <TableRowContentWhite cashFlow={beginningCash} />
                <TableRowContentGray cashFlow={endingCash} />
                <TableRowContentDimGray cashFlow={netChangeinCash} />
              </tbody>
            ) : (
              <tbody className="empty-table" />
            )}
          </table>
        </div>
      </div>
    );
  }
}

export default FNAnalysisFNStatementsCashFlow;



// WEBPACK FOOTER //
// ./src/containers/FNAnalysisFNStatementsCashFlow.js